import React from 'react';


import { List, FilterForm, Datagrid } from 'components/list';
import { TextInput, DateInput } from 'components/input';
import { TextField, NumberField } from 'components/field';

import { SubsPaymentReferenceField } from './SubsOrderPayment';


export const SubsOrderFilter = (props) => (
  <FilterForm name="sub_search" {...props}>
    <DateInput label="From" isRequired={true} source="start_time"/>
    <DateInput label="To" isRequired={true} source="end_time"/>
    <TextInput label="Owner Mobile" source="owner_mobile"/>
    <TextInput label="Shop ID" source="shop_id"/>
  </FilterForm>
);

const listActionOptions = {
  hasExport: true,
  exportFileName: "subscription_order_data.csv",
  exportHeaders: ["ID", "Shop ID", "Price", "Plan", "Status", "Order Type", "Payment", "Order Time"],
  exportSources: ["id", "shop_id", "money_to_pay", "plan", "status", "type", "payment_reference", "add_time"],
};

export const SubsOrderList = (props) => (
  <List {...listActionOptions} {...props} filters={<SubsOrderFilter />}>
    <Datagrid bodyOptions={{ stripedRows: true, showRowHover: true }}>
      <TextField source="id" label="ID"/>
      <TextField source="shop_id" label="Shop ID"/>
      <NumberField source="money_to_pay" label="Price"/>
      <TextField source="plan" label="Plan"/>
      <TextField source="status" label="Status"/>
      <TextField source="type" label="Order Type"/>
      <SubsPaymentReferenceField label="Payment"/>
      <TextField showTime source="add_time" label="Order Time"/>
    </Datagrid>
  </List>
);




// WEBPACK FOOTER //
// ./src/routes/subscription/SubsOrderList.js